export const LOCAL_PREFIX = 'skjv-store/';
export const MIGRATION_FLAG_KEY = `${LOCAL_PREFIX}.migrated-v1`;
export function recordKey(ns, key) {
    return `${LOCAL_PREFIX}${ns}/${key}`;
}
export function recordPrefix(ns) {
    return `${LOCAL_PREFIX}${ns}/`;
}
export function parseRecordKey(storageKey) {
    if (!storageKey.startsWith(LOCAL_PREFIX))
        return null;
    const rest = storageKey.slice(LOCAL_PREFIX.length);
    const slash = rest.indexOf('/');
    if (slash < 0)
        return null;
    return {
        namespace: rest.slice(0, slash),
        key: rest.slice(slash + 1),
    };
}
//# sourceMappingURL=local-key-encoding.js.map